export const temporaryTranslations = {
    LBLN0330:
    "Your order is now being processed. Please wait for a confirmation email to start using your eSIM.",

}